// hooks/useDashboardSummary.js
import useSWR from "swr";
import ManagerDashboardService from "services/ManagerDashboardService";

const fetchDashboardSummary = async (subscriptionPlanId) => {
    return ManagerDashboardService.getDashboardSummary(subscriptionPlanId);
};

const useDashboardSummary = (subscriptionPlanId = "") => {
    const { data, error, isValidating } = useSWR(["dashboardSummary", subscriptionPlanId], () =>
        fetchDashboardSummary(subscriptionPlanId)
    );

    return {
        summary: data,
        isLoading: !error && !data,
        isError: error,
        isValidating,
    };
};

export default useDashboardSummary;
